import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';
import { Questionnaire, QuestionnaireService } from '../questionnaire/questionnaire.service';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class QuestionnaireResolverService  {
  constructor(
    private questionnaire: QuestionnaireService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const id: string = route.paramMap.get('id');
    const qId$ = this.questionnaire.getQuestionnaire(id);

    const mapper = (data: any) => {
      if (data.id) {
        return of(data);

      } else {
        this.router.navigate(['/']);
        return EMPTY;
      }
    };

    return qId$.pipe(mergeMap(mapper));
  }
}
